import { partnersReducer } from './reducers';

export default {
  partners: partnersReducer
};
